var DOC = document;

var CORE = {

	opened: false,

	header: {

		className: 'brtn-header--main',

		elements: null,

		construct: function () {
			var els = DOC.getElementsByClassName(CORE.header.className);
			var i = 0;

			if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
				return false;
			}
			CORE.header.elements = [];

			for (i; i < els.length; i++){
				CORE.header.elements[CORE.header.elements.length] = els[i];
				// els[i].style.display = 'none';
			}

		},

	},

	burger: {

		className: 'brtn-header--main__burger',

		elements: null,

		toggle: function (e) {
			var hActive = CORE.header.className + '--opened-menu';
			var headers = CORE.header.elements;

			e.preventDefault();

			if (headers === null) {
				return;
			}

			if (CORE.opened) {
				$(headers).removeClass(hActive);
				CORE.opened = false;
				return;
			}
			$(headers).addClass(hActive);
			CORE.opened = true;

		},

		construct: function () {
			var els = DOC.getElementsByClassName(CORE.burger.className);
			var i = 0;

			if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
				return false;
			}
			CORE.burger.elements = [];

			for (i; i < els.length; i++){
				CORE.burger.elements[CORE.burger.elements.length] = els[i];
				els[i].addEventListener('click', CORE.burger.toggle);
			}

		},

	},

	menu: {

		className: 'brtn-header--main__nav',

		elements: null,

		construct: function () {
			var els = DOC.getElementsByClassName(CORE.menu.className);
			var i = 0;

			if (els == null || typeof els !== 'object' || !('length' in els) || !els.length) {
				return false;
			}
			CORE.menu.elements = [];

			for (i; i < els.length; i++){
				CORE.menu.elements[CORE.menu.elements.length] = els[i];
				// els[i].style.display = 'none';
			}

		},

	},

	construct: function () {

		CORE.header.construct();
		CORE.burger.construct();
		CORE.menu.construct();

	},


};

export default CORE.construct;
